<mat-form-field class="full-width m-t-20" appearance="outline">
    <mat-label>Select Patient Tags</mat-label>
    <mat-chip-grid #chipGrid aria-label="Enter Tag">
        <mat-chip-row *ngFor="let tag of tagChips; let i = index" (removed)="removeChip(i)" [editable]="false">
            <mat-icon *ngIf="isSurveyTag(tag)" matChipAvatar>sentiment_satisfied</mat-icon>
            {{ tag }}
            <button matChipRemove>
                <mat-icon>cancel</mat-icon>
            </button>
        </mat-chip-row>
        <input #inputElement placeholder="Add Tag Filter..." [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            [formControl]="tagFilterControl" [matAutocomplete]="auto" />
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addChip($event.option.value)">
        <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
            <mat-icon *ngIf="isSurveyTag(tag)">sentiment_satisfied</mat-icon>
            {{ tag }}
        </mat-option>
    </mat-autocomplete>
</mat-form-field>



<ng-container *ngIf="tagChips?.length; else noTags">
    <ng-container *ngIf="filteredPatients.length > 0; else noResults">
        <mat-list>
            <mat-list-item *ngFor="let patient of filteredPatients" (click)="navigateToPatientFile(patient.id)"
                class="auto-height" [appPatientValidationStatus]="patient" #valStatus="appPatientValidationStatus"
                [appPatientActive]="patient.id">
                <div class="patient-item">
                    <div class="patient-details">
                        <app-patient-validation-messages [valStatus]="valStatus"> </app-patient-validation-messages>
                        <div matLine class="patient-name">
                            <b>{{ patient.surname }}, {{ patient.name }}</b>
                            <span class="patient-number" *ngIf="patient.patientNumber">({{ patient.patientNumber
                                }})</span>
                        </div>
                        <div matLine class="patient-diagnosis">
                            <span>{{ patient.diagnosis }}</span>
                        </div>
                        <div matLine *ngIf="patient.diagnosis2" class="patient-secondary-diagnosis">
                            <span>{{ buildDiagnosisString(patient) }}</span>
                        </div>
                        <div matLine class="note-footer">
                            <span *ngIf="patient.tags?.length">Tagged: {{ patient.tags[0]?.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
                            <span *ngIf="patient.survey" class="survey-line">{{ surveyLine(patient.survey) }}</span>
                        </div>
                    </div>
                    <div class="view-icon">
                        <mat-icon>visibility</mat-icon>
                    </div>
                </div>
            </mat-list-item>
        </mat-list>
    </ng-container>
</ng-container>

<div class="mobile-spacer"></div>



<ng-template #noTags>
    <p class="no-records-message">No tags selected. Selected a patient tag to filter.</p>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No patients found.</p>
</ng-template>